import React from 'react';
export function AnnouncementBanner() {
  return <div className="fixed top-0 left-0 right-0 z-[60] bg-[#0066FF] text-white h-10 flex items-center justify-center px-4" data-id="element-187">
      <div className="flex items-center gap-3 text-sm font-sans" data-id="element-188">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#99c2ff" xmlns="http://www.w3.org/2000/svg" data-id="element-189">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-190" />
        </svg>
        <span data-id="element-191">
          Accenture <strong data-id="element-192">2026</strong>{' '}
          <strong data-id="element-193">FinTech Innovation Lab</strong> Demo Day — Finalist
        </span>
      </div>
    </div>;
}